export default __webpack_public_path__ + "static/media/97.5e738e89.jpg";